import { render, staticRenderFns } from "./VideoGallery.vue?vue&type=template&id=265e9a9f&scoped=true&"
import script from "./VideoGallery.vue?vue&type=script&lang=js&"
export * from "./VideoGallery.vue?vue&type=script&lang=js&"
import style0 from "./VideoGallery.vue?vue&type=style&index=0&id=265e9a9f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265e9a9f",
  null
  
)

export default component.exports